import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import classes from './MobilePageHeading.module.css';

type Props = {
   text: string;
   className?: string;
};

const MobilePageHeading = ({ text, className }: Props) => {
   const { t } = useTranslation('common');
   return <h3 className={classNames(classes.mobilePageHeading, className)}>{t(text)}</h3>;
};

export default MobilePageHeading;
